import {BenchlingTypeDef, LeafType, LeafTypeToTSType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {JSONValue} from 'util/Types';

export const MULTI_SUPPORTED_LEAF_TYPES = [
  LeafType.BIOENTITY,
  LeafType.BASIC_FOLDER_ITEM,
  LeafType.MIXTURE,
  LeafType.MOLECULE,
  LeafType.PROTEIN,
  LeafType.SEQUENCE,
  LeafType.ENTRY,
  LeafType.STORABLE,
  LeafType.BOX,
  LeafType.CONTAINER,
  LeafType.LOCATION,
  LeafType.PLATE,
  LeafType.PROCESS,
  LeafType.PROCESS_TASK,
  LeafType.TEAM,
  LeafType.USER,
  LeafType.DROPDOWN_OPTION,
] as const;

export type MultiSupportedLeafType = (typeof MULTI_SUPPORTED_LEAF_TYPES)[number];

export function isMultiSupportedType(leafType: LeafType): leafType is MultiSupportedLeafType {
  return ([...MULTI_SUPPORTED_LEAF_TYPES] as Array<LeafType>).includes(leafType);
}

export type LeafTypeToValueEditorTSType = {
  [key in LeafType]:
    | LeafTypeToTSType[key]
    | null
    | (key extends MultiSupportedLeafType ? Array<LeafTypeToTSType[key]> : never)
    // We need to allow integer inputs to receive strings because intermediate inputs are returned as strings
    // e.g. "10e"
    | (key extends LeafType.INTEGER ? string : never)
    | (key extends LeafType.DECIMAL ? number : never);
};

export interface ValueInputProps<TLeafType extends LeafType> {
  allowAutoFocus: boolean;
  schemaFieldSelectorId?: string;
  schemaId?: string;
  typeDef: BenchlingTypeDef;
  valueInput:
    | {value: LeafTypeToValueEditorTSType[TLeafType]; isValid: true}
    | {value: JSONValue; isValid: false};
  onChange: (newValue: LeafTypeToValueEditorTSType[TLeafType]) => void;
  disabled?: boolean;
  hideSelectedResults?: boolean;
}

export type ValueInputComponentType<TLeafType extends LeafType> = React.FC<ValueInputProps<TLeafType>>;
